import { TemplateElement, defineElement, html } from '@webtides/element-js';
import style from './icon.css';

/**
 * @property {string} name
 * @property {number} size
 */
export default class Icon extends TemplateElement {
    svgSpritePath = window.app_config?.svgSpritePath || '';

    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            name: '',
            size: '',
        };
    }

    template() {
        return html`
            <i class="Icon" data-icon="${this.name}">
                <svg aria-hidden="true"><use href="${this.svgSpritePath}#icon-${this.name}"></use></svg>
            </i>
        `;
    }
}

defineElement('mb-icon', Icon);
